import React from "react";
import { MenaVstupy, PercentaVstupy, IntegerVstupy } from "../vstupneKomponenty";

export default function InvesticneScenareVstupKarta({
  investScenareOpen,
  scenare,
  setInvesticnyScenar,
  porovnajScenare,
  setPorovnajScenare,
}) {
  if (!investScenareOpen) return null;

  return (
    <div className="card-section card-section--invest-scenare card-section--invest-scenare-vstup">
      <div className="invest-scenare-head">
        <h2>Scenáre</h2>

        <div className="toggle-group invest-scenare-compare-toggle">
          <label className="chk">
            <strong>Porovnaj scenáre</strong>
            <input
              type="checkbox"
              checked={porovnajScenare}
              onChange={(e) => setPorovnajScenare(e.target.checked)}
            />
          </label>
        </div>
      </div>

      <div className="invest-scenare-vstup-grid">
        {scenare.map((scenar, index) => (
          <div key={scenar.id} className="invest-scenar-riadok">
            <div className="form form--m invest-scenar-nazov">
              <label className="form_label">Scenár</label>
              <input
                className="form_input"
                type="text"
                value={scenar.nazov}
                maxLength={15}
                onChange={(e) => setInvesticnyScenar(index, {
                  nazov: e.target.value.slice(0, 15),
                })}
              />
            </div>

            <div className="form form--m">
              <label className="form_label">Jednorazovo</label>
              <MenaVstupy
                value={scenar.jednorazovyVklad}
                onChange={(v) => setInvesticnyScenar(index, {
                  jednorazovyVklad: Math.min(999999, Math.max(0, v)),
                })}
                maxDigits={6}
                suffix="€"
                placeholder="0"
              />
            </div>

            <div className="form form--m">
              <label className="form_label">Mesačne</label>
              <MenaVstupy
                value={scenar.mesacnyVklad}
                onChange={(v) => setInvesticnyScenar(index, {
                  mesacnyVklad: Math.min(9999, Math.max(0, v)),
                })}
                maxDigits={4}
                suffix="€"
                placeholder="0"
              />
            </div>

            <div className="form form--m">
              <label className="form_label">Horizont</label>
              <IntegerVstupy
                value={scenar.horizont}
                onChange={(v) => setInvesticnyScenar(index, {
                  horizont: Math.min(50, Math.max(0, v)),
                })}
                maxDigits={2}
                min={0}
                max={50}
                placeholder=" "
              />
            </div>

            <div className="form form--m">
              <label className="form_label">Zhodnotenie</label>
              <PercentaVstupy
                value={scenar.zhodnotenie}
                onChange={(v) => setInvesticnyScenar(index, {
                  zhodnotenie: Math.min(50, Math.max(0, v)),
                })}
                maxInt={2}
                placeholder=" "
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}